/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Media } from '../models/Media';
import type { MediaAttributesForm } from '../models/MediaAttributesForm';
import type { MediaAttributesResponse } from '../models/MediaAttributesResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardMediaService {
    /**
     * @returns Media OK
     * @throws ApiError
     */
    public static getAvailableMedia({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<Array<Media>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/media/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * @returns Media OK
     * @throws ApiError
     */
    public static saveMediaAttributes({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: MediaAttributesForm,
    }): CancelablePromise<Media> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/media/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get media attributes by requested media ID
     * Returns media attributes object that is assigned to media on CH CUI Vault.
     * @returns MediaAttributesResponse Successful response
     * @throws ApiError
     */
    public static getMediaAttributes({
        creatorId,
        mediaId,
    }: {
        /**
         * Creator ID
         */
        creatorId: number,
        /**
         * Media ID for which attributes is requested
         */
        mediaId: number,
    }): CancelablePromise<MediaAttributesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/media/{creatorId}/{mediaId}/attributes',
            path: {
                'creatorId': creatorId,
                'mediaId': mediaId,
            },
            errors: {
                403: `Forbidden access`,
            },
        });
    }
    /**
     * Get media attributes by requested media ID
     * Returns media attributes object that is assigned to media on CH CUI Vault.
     * @returns MediaAttributesResponse Successful response
     * @throws ApiError
     */
    public static listMediaAttributes({
        creatorId,
        mediaIds,
    }: {
        /**
         * Creator ID
         */
        creatorId: number,
        /**
         * Media IDs for which attributes is requested
         */
        mediaIds: Array<number>,
    }): CancelablePromise<Array<MediaAttributesResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/media/{creatorId}/attributes',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'mediaIds': mediaIds,
            },
            errors: {
                403: `Forbidden access`,
            },
        });
    }
}
